import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { error } from 'core/utils/error-decorator';
import { Observable, map } from 'rxjs';
import { ResourceItemsResponse } from 'user/models/resource-item-data';
import { FeatureToggleService } from '../../services/feature-toggle.service';
import { RollupResultsV2, SearchRequestBody, SearchResult } from '../models/search-results';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private static readonly searchUrl = 'api/search';
  private static readonly searchResultUrl = 'api/search-result/search';

  constructor(
    private readonly http: HttpClient,
    private readonly featureToggleService: FeatureToggleService,
  ) {}

  public getSearchResults(searchRequestBody: SearchRequestBody): Observable<RollupResultsV2> {
    return this.http.post<RollupResultsV2>(SearchService.getSearchUrl(), searchRequestBody, {headers: {'api-version': '2'}});
  }

  @error([])
  public getResource(resourceId: string | string[]): Observable<SearchResult[]> {
    const entityIds = resourceId instanceof Array ? resourceId : Array.of(resourceId);
    const useNewApi = this.featureToggleService.getToggles()['VDIS-33935_2025-07-31_new_instance_api'];
    const url = useNewApi
      ? `api/search-result/search/instances/${entityIds[0]}`
      : `api/search/resources/all?id=${entityIds.join(',')}`;

    return this.http.get<SearchResult>(url).pipe(
      map(response => {
        return Array.isArray(response) ? response : [response];
      })
    );
  }
  @error([])
  public getMetadataIds(ids: string[]): Observable<ResourceItemsResponse> {
    return this.http.get<ResourceItemsResponse>(`${SearchService.searchUrl}/resources/all_meta`, {
      params: {
        id: ids.join(','),
      },
    });
  }

  private static getSearchUrl() {
    return `${SearchService.searchResultUrl}/format-groups`;
  }
}
